// Tiny zero-dep SVG sparkline. Renders a poly-line of the given data
// scaled to [0, 1] within the given dimensions. Used by the trends block
// and the Sentry health 30d strip.

interface Props {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
  fill?: string;
}

export function Sparkline({
  data,
  width = 80,
  height = 20,
  color = '#a5b4fc',
  fill,
}: Props) {
  if (!data || data.length === 0) {
    return (
      <svg width={width} height={height} className="text-slate-700">
        <line
          x1={0}
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke="currentColor"
          strokeWidth={1}
        />
      </svg>
    );
  }

  const max = Math.max(...data, 1);
  const min = 0;
  const range = max - min || 1;
  const stepX = data.length > 1 ? width / (data.length - 1) : 0;

  const points = data.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * height;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });

  const polyline = points.join(' ');
  const areaPath = fill
    ? `M0,${height} L${points.join(' L')} L${width},${height} Z`
    : null;

  return (
    <svg width={width} height={height} aria-hidden>
      {areaPath && <path d={areaPath} fill={fill} />}
      <polyline
        points={polyline}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
